<template>
  <div v-infinite-scroll="loadNextPage" infinite-scroll-disabled="busy" infinite-scroll-distance="4">
   <div class="container m-auto">
    <div class="flex flex-wrap content-center justify-start">
      <div class="w-full">
        <ul class="breadcrumb text-sm md:text-base">
          <li class="is-active">
            <p>{{ category_name }}</p>
          </li>
        </ul>
      </div>
      <div class="w-full px-1 py-3">
        <div class="flex flex-wrap content-center justify-start" v-lazy-container="{ selector: 'img' }">
          <div class="product-card hvr-grow py-4 px-3 mb-4 w-full sm:w-1/2 md:w-4/12 lg:w-3/12" v-for="product in products">
            <div class="max-w-sm rounded-lg shadow-product bg-white relative overflow-hidden">
              <a :href="product.link">
                <img class="image" :data-src="product.image" :alt="product.name">
              </a>
              <div class="details">
                <div class="title">
                  {{ product.name }}
                </div>
                <div class="price">
                  <span class="before-discount" v-if="product.offer_price != null">{{ product.price +' '+ currency }}</span>
                  <span class="current" v-if="product.offer_price != null">{{ product.offer_price +' '+ currency }}</span>
                  <span class="current" v-if="product.offer_price == null">{{ product.price +' '+ currency }}</span>
                </div>
                <div class="add-to-cart">
                  <template v-if="product.stock > 0 && product.active  && product.available"> 
                    <number-input :value="1" size="small" :min="product.min" :max="product.stock >= product.max ? product.max : product.stock" inline center controls class="number-input"></number-input>
                    <button type="submit" :data-product-id="product.id" id="addToCart" class="add-to-cart-button">
                      <i class="icon icon-cart"></i>
                    </button>
                  </template>
                  <template v-else>
                    <p class="text-center text-white font-semibold px-3 py-2 w-full">{{t('unvailable_product')}}</p>
                  </template>
                </div>
                <div class="label-tags" v-if="product.label != 'none' && !product.label_expire_date">
                  <span>{{ product.translated_label }}</span>
                </div>
              </div>
              <div class="discount" v-if="product.offer_price">
                <span>{{ product.offer_percentage }}% {{t('discount')}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="has-text-centered m-t-30" v-show="loadMore">
        <a href="#" class="load-more">
          <img src="/front/img/illustrations/load_more.svg">
          <span>{{ t('more') }}</span>
        </a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import axios from 'axios';
  import NumberInput from '@chenfengyuan/vue-number-input';
  import infiniteScroll from 'vue-infinite-scroll';
  export default {
    name: "Offers",
    components: {
      'number-input' : NumberInput,
    },
    directives: {
      infiniteScroll
    },
    props: {
      url: String,
      landing : {
        type: String,
        required: true
      },
      currency: String,
      more:String,
      category_name:String,
      sitelocale:{
        type: String,
        required: true
      }
    },
    computed: {
      busy() {
        return this.fetching
      }
    },
    data(){
      return {
        currentPage: 0,
        page: 1,
        fetching: true,
        nextUrl : String,
        loadMore : false,
        products: [],
      };
    },
    mounted() {
      this.$translate.setLang(this.sitelocale);
    },
    created() {
      this.nextUrl = this.url;
      this.products = [];
      this.loadNextPage();
    },
    methods: {
      loadNextPage() {
        this.currentPage++;
        this.fetching = true;
        if(this.nextUrl != null){
          axios.get(this.nextUrl).then(({ data }) => {
            this.products.push(...data.data);
            if(data.links.next != null) {
              this.loadMore = true;
              this.nextUrl = data.links.next;
            } else {
              this.nextUrl = data.links.next;
            }
            this.fetching = false;
          });
        }
        else{
          this.loadMore = false;
        }
      },
      submit(input){
        if(input){
          window.location.href = `${this.link}?search=${input}`;
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/front/components/SiteComponents/Offers/Index.vue